// extracted by mini-css-extract-plugin
module.exports = {"root":"BasicButton_root__lorIB","rootPadding":"BasicButton_rootPadding__GPVvm"};